import React, {Component} from "react";
import {connect} from "react-redux";
import Button from '@mui/material/Button/index';
import withStyles from "@mui/styles/withStyles";
import CardContent from "@mui/material/CardContent/index";
import SnackbarMessage from "../Custom/SnackbarMessage";
import TextField from "@mui/material/TextField";
import CircularProgress from '@mui/material/CircularProgress';
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import {useHistory} from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import Validator from "../../utilities/validator";
import PrivacyPolicy from "../Dialogs/PrivacyPolicy";
import TermsOfService from "../Dialogs/TermsOfService";
import {clear_auth_messages, clear_register_error, register} from "../../actions/auth";
import {switchMode} from "../../actions/theming";

const styles = {
    // loginPage: {
    //     height: "95vh",
    //     paddingTop: "5vh",
    //     // background: "url(" + bg + ")",
    //     backgroundPosition: "center",
    //     backgroundRepeat: "no-repeat",
    //     backgroundSize: "cover"
    // },
    input: {
        marginBottom: 20
    },
    loginWrapper: {
        textAlign: "center",
        paddingTop: "40px",
        marginBottom: "60px",
        minHeight: "calc(100vh - 83px)",
    },
    centered: {
        "text-align": "center",
        "paddingTop": 24,
        "paddingBottom": 24
    },
    logo: {
        paddingTop: 15,
        paddingBottom: 15,
        fontWeight: "bold",
        color: "white"
    },
    spanLink: {
        textDecoration: "underline",
        cursor: "pointer",
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -10,
        marginLeft: -10,
    },
    buttonProgressContainer: {
        position: 'relative'
    },
    darkModeSwitch: {
        position: "fixed",
        top: "10px",
        right: "10px"
    }
};

class Register extends Component {
    constructor(props) {
        super(props);
        this.recaptchaRef = React.createRef();
        this.state = {
            privacyPolicyOpened: props.match.path === "/auth/registration/privacy-policy",
            termsOfServiceOpened: props.match.path === "/auth/registration/terms",
            firstName: '',
            firstNameTouched: false,
            lastName: '',
            lastNameTouched: false,
            email: '',
            emailTouched: false,
            password: '',
            passwordTouched: false,
            password2: '',
            password2Touched: false,
            gdprChecked: false
        };
    }

    componentDidMount() {
        this.props.clear_auth_messages();
    }

    onSubmit = e => {
        e.preventDefault();
        this.recaptchaRef.current.execute().then(res => {
            const recaptchaToken = res;
            const {firstName, lastName, email, password, password2} = this.state;

            if (
                Validator.isNameValid(firstName) &&
                Validator.isNameValid(lastName) &&
                Validator.isEmailValid(email) &&
                Validator.isPasswordValid(password) &&
                password === password2
            ) {
                const registered = this.props.register(firstName, lastName, email, password, recaptchaToken);
                if (registered) {
                    useHistory().push('/auth/login');
                }
            } else {
                this.setState({
                    firstNameTouched: true,
                    lastNameTouched: true,
                    emailTouched: true,
                    passwordTouched: true
                })
            }
        });

    };

    onChange = e => this.setState({
        [e.target.name]: e.target.value,
        [e.target.name + 'Touched']: true
    });

    openPrivacyPolicy = () => {
        this.setState({
            ...this.state,
            privacyPolicyOpened: true
        });
    };

    closePrivacyPolicy = () => {
        this.setState({
            ...this.state,
            privacyPolicyOpened: false
        });
    };

    openTermsOfService = () => {
        this.setState({
            ...this.state,
            termsOfServiceOpened: true
        });
    };

    closeTermsOfService = () => {
        this.setState({
            ...this.state,
            termsOfServiceOpened: false
        });
    };

    render() {
        if (this.props.auth.register_success) {
            this.props.history.push("/");
        }

        let errors;
        if (Object.keys(this.props.auth.errors).length > 0) {
            let errors_array = [];
            Object.keys(this.props.auth.errors).map((field) => {
                errors_array = [...errors_array, ...this.props.auth.errors[field]];
            });
            errors = (
                <>
                    <SnackbarMessage onClose={this.props.clear_register_error} type="error"
                                     message={errors_array.join(", ")} autoHideDuration={null} anchorOrigin={false}
                                     style={{marginBottom: 15}}/>
                </>
            )
        } else {
            errors = false
        }
        const {classes} = this.props;
        const {
            privacyPolicyOpened,
            termsOfServiceOpened,
            firstName,
            firstNameTouched,
            lastName,
            lastNameTouched,
            email,
            emailTouched,
            password,
            passwordTouched,
            password2,
            password2Touched,
            gdprChecked
        } = this.state;

        let content = (
            <>
                <form onSubmit={this.onSubmit} id="registration">
                    <CardContent>
                        {errors}
                        <TextField autoFocus fullWidth label="E-mail" variant="outlined" required
                                   type="email" name="email" onChange={this.onChange} value={email}
                                   disabled={this.props.auth.is_waiting}
                                   className={classes.input} error={emailTouched && !Validator.isEmailValid(email)}
                                   helperText={emailTouched && !Validator.isEmailValid(email) ? "Please enter a valid e-mail" : ""}
                        />
                        <TextField fullWidth label="First name" variant="outlined" required
                                   type="text" name="firstName" onChange={this.onChange} value={firstName}
                                   disabled={this.props.auth.is_waiting}
                                   className={classes.input}
                                   error={firstNameTouched && !Validator.isNameValid(firstName)}
                                   helperText={firstNameTouched && !Validator.isNameValid(firstName) ? "Please enter a valid first name" : ""}
                        />
                        <TextField fullWidth label="Last name" variant="outlined" required
                                   type="text" name="lastName" onChange={this.onChange} value={lastName}
                                   disabled={this.props.auth.is_waiting}
                                   className={classes.input} error={lastNameTouched && !Validator.isNameValid(lastName)}
                                   helperText={lastNameTouched && !Validator.isNameValid(lastName) ? "Please enter a valid last name" : ""}
                        />
                        <TextField fullWidth label="Password" variant="outlined" required
                                   type="password" name="password" onChange={this.onChange} value={password}
                                   disabled={this.props.auth.is_waiting}
                                   className={classes.input}
                                   error={passwordTouched && !Validator.isPasswordValid(password)}
                                   helperText={passwordTouched && !Validator.isPasswordValid(password) ? "Minimum 8 characters, at least one uppercase letter, one lowercase letter and one number" : ""}
                        />
                        <TextField fullWidth label="Password repeat" variant="outlined" required
                                   type="password" name="password2" onChange={this.onChange} value={password2}
                                   disabled={this.props.auth.is_waiting}
                                   className={classes.input} error={password2Touched && password2 !== password}
                                   helperText={password2Touched && password2 !== password ? "Please confirm your password" : ""}
                        />
                        <ReCAPTCHA
                            ref={this.recaptchaRef}
                            size="invisible"
                            sitekey="6LcpS7kaAAAAACvn4UE6Mui2XRYfVyOSZROzvF9I"
                            style={{zIndex: "9999999"}}
                            theme={this.props.theming.darkMode ? 'dark' : 'light'}
                            // onChange={onChange}
                        />
                        <Typography className={classes.input}>
                            By clicking SIGN UP FOR FREE, you agree to the <span className={classes.spanLink}
                                                                                 onClick={this.openTermsOfService}>Terms of Service</span> and <span
                            className={classes.spanLink} onClick={this.openPrivacyPolicy}>Privacy Policy</span>
                        </Typography>
                        <div className={classes.buttonProgressContainer}>
                            <Button type="submit"
                                    variant="contained"
                                //color="rgb (191, 191, 191)"
                                    color="grey"
                                    size="large"
                                    style={{width: "100%"}}
                                    disabled={this.props.auth.is_waiting}
                            >
                                SIGN UP FOR FREE
                            </Button>
                            {this.props.auth.is_waiting &&
                                <CircularProgress size={20} className={classes.buttonProgress}/>}
                        </div>

                        <Divider variant="middle" style={{margin: "20px 0"}}/>
                        <Typography style={{marginBottom: "20px", textAlign: "center"}}>Already have an
                            account?</Typography>
                        <Button type="button"
                                variant="contained"
                                color="primary"
                                size="large"
                                style={{marginTop: "20px 0", width: "100%"}}
                                disabled={this.props.auth.is_waiting}
                                onClick={() => {
                                    this.props.history.push("/auth/login");
                                }}
                        >
                            Log in
                        </Button>
                    </CardContent>
                </form>
                <PrivacyPolicy open={privacyPolicyOpened} closeHandle={this.closePrivacyPolicy}/>
                <TermsOfService open={termsOfServiceOpened} closeHandle={this.closeTermsOfService}/>
            </>
        );

        return content;
    }

}

const mapStateToProps = state => ({
    auth: state.auth,
    theming: state.theming
});

export default withStyles(styles)(connect(
    mapStateToProps,
    {register, clear_register_error, switchMode, clear_auth_messages}
)(Register));

